<template>
  <div class="sms">
    <div class="top">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
        alt=""
      />
      <div class="name">betterWE星球</div>
      <div class="desc">健萌集团旗下产品</div>
    </div>
    <div class="bottom">
      <div class="download" @click="bindDownload">下载betterWE星球APP</div>
      <div class="tips">如未下载APP，请点击按钮下载或者在应用商店下载</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {
    this.$http.bindH5UMA('BG_JM_EVENTS_kcdk_SMS')
    let url = `${location.origin}/activity/spring-festival-course-reservation`
    location.href = `betterwe://btwx.gymcity.com.cn/?newPath=/web?url=${encodeURIComponent(
      url
    )}`
  },
  methods: {
    bindDownload() {
      this.$http.bindH5UMA('CLICK_JM_EVENTS_kcdk_SMS_DL')
      this.$router.push('/app-download')
    }
  }
}
</script>
<style lang="scss" scoped>
.sms {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .top {
    margin-top: 172px;
    margin-bottom: 265px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .logo {
      width: 59px;
      height: 59px;
      object-fit: contain;
      margin-bottom: 13px;
    }
    .name {
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 18px;
      color: #303038;
      line-height: 24px;
    }
    .desc {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 10px;
      color: #303038;
      line-height: 20px;
      letter-spacing: 5px;
    }
  }
  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .download {
      width: 190px;
      height: 40px;
      background: #1693e9;
      border-radius: 6px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
    }
    .tips {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 18px;
    }
  }
}
</style>
